import {graphql, useStaticQuery} from "gatsby";
import {useI18next} from "gatsby-plugin-react-i18next";
export const useACFOptions = () => {
  const opts = useStaticQuery(graphql`
    query {
      en : wp {
        optionsACF {
          globalOptionsACF {
            footer {
              copyright
              socials {
                icon
                url
              }
              title
              whitepaper {
                title
                links {
                  text
                  file {
                    localFile {
                      publicURL
                    }
                  }
                }
              }
            }
            subscribe {
              suptitle
              text
              title
            }
            header {
              contactLink {
                title
                url
                target
              }
            bridgeLink {
                title
                url
                target
              }

            }
          }
        }
      }
      es : wp {
        optionsACFes {
          globalOptionsACF {
            footer {
              copyright
              socials {
                icon
                url
              }
              title
              whitepaper {
                title
                links {
                  text
                  file {
                    localFile {
                      publicURL
                    }
                  }
                }
              }
            }
            subscribe {
              suptitle
              text
              title
            }
            header {
              contactLink {
                title
                url
                target
              }
              bridgeLink {
                title
                url
                target
              }
            }
          }
        }
      }
    }
  `);
  const { language, defaultLanguage} = useI18next();

  const langSlug = language !== defaultLanguage ? language : '';
  const otps = opts[language][`optionsACF${langSlug}`]?.globalOptionsACF;

  return otps;
};
